import {makeActionCreator} from '../utility'

export const FETCH_APPLICATION_TYPES = 'FETCH_APPLICATION_TYPES'
export const fetchApplicationTypes = makeActionCreator(FETCH_APPLICATION_TYPES, 'data')

export const APPLICATION_TYPES_RECEIVED = 'APPLICATION_TYPES_RECEIVED'
export const  applicationTypesReceived= makeActionCreator(APPLICATION_TYPES_RECEIVED, 'data')